import React, { useRef, useState, useEffect } from "react";
import Cookies from "js-cookie";
import moment from "moment";
import { toast } from "react-toastify";

const AddBatteryDetails = ({ setimgfile, formRef, getData }) => {
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [vehicle, setVehicle] = useState([]);
  const [Company, setCompany] = useState([]);
  const [Staff, setStaff] = useState([]);
  // console.log(Material)
  const [rowAddData, setRowAddData] = useState({
    battery_num: "",
    battery_brand: "",
    specification: "",
    warrenty_guarantee: "",
    purchase_date: "",
  });
  const [selectedVehicleId, setSelectedVehicleId] = useState("");
  const [selectedCompanyId, setSelectedCompanyId] = useState("");
  const [selectedStafflId, setSelectedStaffId] = useState("");
  function resetFileds() {
    setRowAddData({
      battery_num: "",
      battery_brand: "",
      specification: "",
      warrenty_guarantee: "",
      purchase_date: "",
    });
    setSelectedStaffId("");
    setSelectedVehicleId("");
    setSelectedCompanyId("");
  }

  const handleVehicleChange = (e) => {
    setSelectedVehicleId(e.target.value);
  };

  const handleStaffChange = (e) => {
    setSelectedStaffId(e.target.value);
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setRowAddData(() => {
      return {
        ...rowAddData,
        [name]: value,
      };
    });
  };

  const handleAddDataSubmit = async (e) => {
    e.preventDefault();
    const {
      battery_num,
      battery_brand,
      specification,
      warrenty_guarantee,
      purchase_date,
    } = rowAddData;

    let BASE_URL = SERVER_URL + `/api/battery/battery-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "POST",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        company_id: selectedCompanyId,
        vehicle_id: selectedVehicleId,
        driver_id: selectedStafflId,
        battery_num,
        battery_brand,
        specification,
        warrenty_guarantee,
        purchase_date: moment(purchase_date).format("YYYY-MM-DD"),
      }),
    });
    const response = await res.json();

    if (res.ok) {
      setTimeout(() => {
        toast.success(response.message);
        resetFileds();
        getData();
        // formRef.current.reset();
        // navigate("/dashboard");
      }, 1000);
    } else {
      toast.error(response.message);
      getData();
    }
  };

  const getVehicle = async () => {
    let BASE_URL =
      SERVER_URL + `/api/vehicle-details/all-vehicle-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setVehicle(result.data);
  };

  useEffect(() => {
    getVehicle();
  }, []);

  const getCompany = async () => {
    const BASE_URL = SERVER_URL + `/api/company/all-company-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    // console.log(result.data)
    setCompany(result.data);
  };

  useEffect(() => {
    getCompany();
  }, []);

  const getStaff = async (e) => {
    // console.log(e.target.value)
    setSelectedCompanyId(e.target.value);
    const companyID = e.target.value;
    const BASE_URL =
      SERVER_URL +
      `/api/staff-detials/drop-staffDetails/${user_id}?company_id=${companyID}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    setStaff(result.data);
  };
  return (
    <>
      <div
        className="modal custom-modal fade"
        id="exampleModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Add Battery Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFileds}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    {/* <h4 className="card-title">Add Party Name</h4> */}
                    <form
                      className="form-sample"
                      ref={formRef}
                      onSubmit={handleAddDataSubmit}
                    >
                      {/* <p className="card-description">Personal info</p> */}
                      <div className="row">
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="company_name">Company Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={(e) => getStaff(e)}
                              value={selectedCompanyId}
                              id="company_name"
                              required
                            >
                              <option value="">Select Company Name</option>
                              {Company &&
                                Company?.length > 0 &&
                                Company?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.company_name}, ${item.location}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="staff_id">Driver Name</label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleStaffChange}
                              value={selectedStafflId}
                              id="staff_id"
                              required
                            >
                              <option value="">Select Driver Name</option>
                              {Staff &&
                                Staff?.length > 0 &&
                                Staff?.map((item, index) => {
                                  return (
                                    <React.Fragment key={index}>
                                      <option
                                        value={item.id}
                                      >{`${item.staff_name}`}</option>
                                    </React.Fragment>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="material_name">
                              Vehicle Number
                            </label>
                            <select
                              className="form-control form-control-lg"
                              onChange={handleVehicleChange}
                              value={selectedVehicleId}
                              id="material_name"
                              required
                            >
                              <option value="">Select Vehicle</option>
                              {vehicle &&
                                vehicle?.length > 0 &&
                                vehicle?.map((item, id) => {
                                  return (
                                    <option
                                      value={item.id}
                                      key={id}
                                    >{`${item.vehicle_number}`}</option>
                                  );
                                })}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="battery_num">Battery Number</label>
                            <input
                              type="text"
                              className="form-control"
                              name="battery_num"
                              id="battery_num"
                              placeholder="Battery Number"
                              onChange={handleChange}
                              value={rowAddData.battery_num}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="battery_brand">Battery Brand</label>
                            <input
                              type="text"
                              className="form-control"
                              name="battery_brand"
                              id="value"
                              placeholder="Battery Brand"
                              onChange={handleChange}
                              value={rowAddData.battery_brand}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="specification">Specification</label>
                            <input
                              type="text"
                              className="form-control"
                              name="specification"
                              id="specification"
                              placeholder="Specification"
                              onChange={handleChange}
                              value={rowAddData.specification}
                              required
                              min="1"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="warrenty_guarantee">
                              Warrenty Guarantee
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              name="warrenty_guarantee"
                              id="warrenty_guarantee"
                              placeholder="Warrenty Guarantee"
                              onChange={handleChange}
                              value={rowAddData.warrenty_guarantee}
                              required
                              min="1"
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-3">
                          <div className="form-group">
                            <label htmlFor="purchase_date">Purchase Date</label>
                            <input
                              type="date"
                              className="form-control"
                              name="purchase_date"
                              id="purchase_date"
                              placeholder="Purchase Date"
                              onChange={handleChange}
                              value={rowAddData.purchase_date}
                              autoComplete="off"
                            />
                          </div>
                        </div>
                      </div>
                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                        // onClick={handleAddDataSubmit}
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddBatteryDetails;
